import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, css, styled } from '@mui/material'

import { COLORS, unit } from '@hcr/ui'

export const Link = styled(Button)<{ $disableBorderBottom?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: ${unit(4)} ${unit(7)};
  color: ${COLORS.black};

  ${props =>
    !props.$disableBorderBottom &&
    css`
      border-bottom: ${unit(0.25)} solid ${COLORS.vaalea[600]};
    `}
` as typeof Button

export const Icon = styled(FontAwesomeIcon)`
  font-size: ${unit(5)};
`
